import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { money } from '../lib/format.js';

export default function Dashboard() {
  const { t } = useTranslation();
  const { data } = useQuery({ queryKey: ['dashboard'], queryFn: () => api('/api/reports/dashboard') });
  const { data: aging } = useQuery({ queryKey: ['aging'], queryFn: () => api('/api/reports/aging') });
  return (
    <>
      <div className="page-header"><h1>{t('nav.dashboard')}</h1></div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16 }}>
        <Card label="Outstanding" value={money(data?.outstanding || 0)} tone="warning" />
        <Card label="Overdue invoices" value={String(data?.overdueCount ?? 0)} tone="danger" />
        <Card label="This month revenue" value={money(data?.monthRevenue || 0)} sub={`${data?.monthInvoices ?? 0} invoices`} />
        <Card label="This year revenue" value={money(data?.yearRevenue || 0)} sub={`${data?.yearInvoices ?? 0} invoices`} />
      </div>
      <div className="card mt-16">
        <h2>Aging</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 12 }}>
          {[
            ['Current', aging?.buckets?.current],
            ['1–30 days', aging?.buckets?.d30],
            ['31–60 days', aging?.buckets?.d60],
            ['61–90 days', aging?.buckets?.d90],
            ['90+ days', aging?.buckets?.d90plus],
          ].map(([label, v]) => (
            <div key={label} style={{ background: 'var(--sky-pale)', padding: 12, borderRadius: 8, textAlign: 'center' }}>
              <div className="muted" style={{ fontSize: 11, textTransform: 'uppercase' }}>{label}</div>
              <div style={{ fontSize: 18, fontWeight: 600, color: 'var(--navy-900)' }}>{money(v || 0)}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
function Card({ label, value, sub, tone }) {
  const color = tone === 'danger' ? 'var(--danger)' : tone === 'warning' ? 'var(--warning)' : 'var(--navy-900)';
  return (
    <div className="card">
      <div className="muted" style={{ fontSize: 12, textTransform: 'uppercase', letterSpacing: '.05em' }}>{label}</div>
      <div style={{ fontSize: 24, fontWeight: 600, color, marginTop: 4 }}>{value}</div>
      {sub && <div className="muted" style={{ fontSize: 12 }}>{sub}</div>}
    </div>
  );
}
